// extracted by mini-css-extract-plugin
export default {"hidden":"downloadTruckPreparationPDFModal_hidden__XDn+W"};